
import About from '../views/About.vue'
import Contact from '../views/Contact.vue'
import Home from '../views/Home.vue'
import Login from '../views/Login.vue'
import Logout from '../views/Logout.vue'
import Event from '../views/Event.vue'
import Checkout from '../views/Checkout.vue'
import OrderReceived from '../views/OrderReceived.vue'
import Tickets from '../views/Tickets.vue'
import Ticket from '../views/Ticket.vue'
import Privacy from '../views/Privacy.vue'
import Terms from '../views/Terms.vue'
import ForgotPassword from '../views/ForgotPassword.vue'
import PasswordReset from '../views/PasswordReset.vue'
import StartSelling from '../views/StartSelling.vue'

function guardMyRoute(to, from, next) {
	if (localStorage.getItem('userData') == null || localStorage.getItem('userData') == "null") {
		next({ name: 'Login' })
	}
	else {
		next()
	}
}

function closePage(to, from, next) {
  window.close()
}

export const routers=[
    {
      path: '/' , component: Home
    },
    {
     path:'/about', component:About
    },
     {
      path:'/checkout/success', 
      component:OrderReceived,
      name: 'OrderReceived',
      props: true
     },
     {
      path:'/contact', component:Contact
     },
     {
      path:'/login', 
			component:Login,
			name: 'Login',
     },
     {
      path:'/logout', 
      component:Logout,
      beforeEnter : guardMyRoute,
     },
     {
      path:'/event/:id', 
      component:Event,
      name: 'Event',
      props: true
     },
		 {
      path:'/checkout', 
			component:Checkout,
			name: 'Checkout',
     },
		 {
      path:'/t/:id', 
      component:Ticket,
      name: 'Ticket',
      props: true
     },
		 {
      path:'/privacy', 
      component:Privacy,
      name:Privacy
     },
		 {
      path:'/terms', 
      component:Terms,
      name:Terms
     },
		 {
      path:'/password/forgot', 
      component:ForgotPassword,
      name:ForgotPassword
     },
		 {
      path:'/password/reset', 
      component:PasswordReset,
      name:PasswordReset
     },
     {
      path:'/tickets', 
      component:Tickets,
      beforeEnter : guardMyRoute,
     },
     {
      path:'/pesapal', 
      beforeEnter : closePage,
     },
		 {
      path:'/start-selling', 
      component: StartSelling,
     },
]